import {
  GeneratePatientVideoCallTokenMutation,
  GeneratePatientVideoCallTokenDocument,
  GeneratePatientVideoCallTokenInput,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

export type GeneratePatientVideoCallTokenReturn =
  GeneratePatientVideoCallTokenMutation['generatePatientVideoCallToken']

export const generatePatientVideoCallToken = async (
  input: GeneratePatientVideoCallTokenInput,
): Promise<GeneratePatientVideoCallTokenReturn> => {
  try {
    const res = await graphqlRequest(GeneratePatientVideoCallTokenDocument, {
      input,
    })
    return res.generatePatientVideoCallToken
  } catch (error) {
    throw error
  }
}
